import React from 'react';
import { GelRowLayout, GelTabs, GelTab } from '@tal-gel/components';
import { get, isEmpty } from 'lodash';

import InsuredParty from './InsuredParty';
import ContactDetails from './contactDetails';
import CoverDetails from '../CoverDetails/CoverDetails';

export default function RecordDetails(props) {
    let policyLives;
    const coverDetails = props.coverDetails;
    const policyDetails = props.policyDetails;
    const policies = props.policies;

    if (!props.policyLives || isEmpty(props.policyLives)) {
        policyLives = [0];
    } else {
        policyLives = props.policyLives;
    }

    return (
        <GelTabs condensed>
            {policyLives.map((policyLife, index) =>
                <GelTab key={ index } title={ get(policyLife, 'fullName', '') }>
                    <GelRowLayout>
                        <InsuredParty insuredParty= { policyLife }></InsuredParty>
                    </GelRowLayout>

                    <GelRowLayout style={{ padding: '24px 0' }}>
                        <hr/>
                    </GelRowLayout>

                    <GelRowLayout>
                        <ContactDetails insuredParty={ policyLife }></ContactDetails>
                    </GelRowLayout>

                    <GelRowLayout style={{ padding: '24px 0' }}>
                        <hr/>
                    </GelRowLayout>

                    <GelRowLayout>
                        <CoverDetails coverDetails={ props.coverDetails } insuredParty={ policyLife } policyDetails={props.policyDetails} policies = {props.policies}></CoverDetails>
                    </GelRowLayout>
                </GelTab>
            )}
        </GelTabs>
    );
}